// start:ng42.barrel
export * from './reservation-login-required-check.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-login-required-check/index.ts